import { Drawer, Link } from '@coolblue-development/freddy';
import styled from '@emotion/styled';
export const MainImageContainer = styled(Link) `
  width: 100%;

  img {
    border: ${({ theme }) => theme.borderWidth[25]} solid
      ${({ theme }) => theme.color.border.interactiveBase};
    border-radius: ${({ theme }) => theme.borderRadius[100]};
  }
`;
export const StyledDrawer = styled(Drawer) `
  ${({ theme }) => theme.breakpoint.maxWidth('md')} {
    animation: ${({ theme, open }) => open ? theme.motionAnimation.slideInBottom : theme.motionAnimation.slideOutBottom}
      ${({ theme }) => theme.motionDuration.fast} ${({ theme }) => theme.motionEasing.easeOut}
      forwards;
    bottom: 0;
    top: initial;
    width: 100%;
    max-width: initial;
    height: 85%;
    border-radius: ${({ theme }) => theme.borderRadius[200]}
      ${({ theme }) => theme.borderRadius[200]} 0 0;
  }
`;
//# sourceMappingURL=ManufacturersSpecifications.styled.js.map